export { default } from './RootNavigator';
export * from './RootNavigator';
